import React from 'react';
import './Footer.css'; // Importing the CSS file


export const Footer = () => {
    return (
        <footer className="footer">
           
            <div className="footer-content">
            
                <p>Website by Tom Burns-Tinkler, Created with React</p>
                <p>Thank you for visiting 👩‍🚀🚀</p>
                
            </div>
        </footer>
    );
}

